import React from 'react';
import {
	ListItem,
	Box,
	Typography,
	useTheme,
	LinearProgress,
	linearProgressClasses,
} from '@mui/material';
import { useTranslation } from 'services/localization';

export interface Props {
	title: string;
	completedItems: number;
	itemsInTotal: number;
	onClick: () => void;
}
const OnboardingStepHeader = (props: Props) => {
	const { title, completedItems, itemsInTotal, onClick } = props;
	const { t } = useTranslation();
	const theme = useTheme();
	const done = completedItems === itemsInTotal;
	const stepsLeft = itemsInTotal - completedItems;
	return (
		<>
			<ListItem
				sx={{
					p: '24px 32px',
					'&:hover': {
						backgroundColor: (theme) => theme.palette.action.hover,
						cursor: 'pointer',
						borderRadius: '5px 5px 0 0',
					},
				}}
				onClick={onClick}
			>
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
						width: '100%',
						gap: 1,
					}}
				>
					<Typography
						sx={{
							fontWeight: '500',
							color: done ? theme.palette.text.secondary : theme.palette.text.primary,
							flex: '1',
						}}
					>
						{title}
					</Typography>
					<Typography
						variant="body2"
						sx={{
							color: done ? theme.palette.success.dark : theme.palette.colors.tundra.main,
							textAlign: 'right',
							'@media (max-width:440px)': {
								flex: done ? '0 1 0' : undefined,
							},
						}}
					>
						{done
							? t('homeView.onboarding.allStepsCompleted', 'All steps completed')
							: stepsLeft > 1
							? stepsLeft + ' ' + t('homeView.onboarding.stepsLeft', 'steps left')
							: stepsLeft + ' ' + t('homeView.onboarding.stepLeft', 'step left')}
					</Typography>
				</Box>
			</ListItem>
			<LinearProgress
				sx={{
					height: '4px',
					width: '100%',
					[`& .${linearProgressClasses.bar}`]: {
						backgroundColor: theme.palette.success.main,
						borderRadius: '0 0 5px 5px',
					},
					[`&.${linearProgressClasses.colorPrimary}`]: {
						backgroundColor: theme.palette.action.hover,
						borderRadius: '0 0 5px 5px',
					},
				}}
				variant="determinate"
				value={(completedItems / itemsInTotal) * 100}
			/>
		</>
	);
};

export default OnboardingStepHeader;
